function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3 12C3 10.3431 4.34315 8.99997 6 8.99997H16C17.6569 8.99997 19 10.3431 19 12V22C19 23.6568 17.6569 25 16 25H6C4.34315 25 3 23.6568 3 22V12ZM6 11C5.44772 11 5 11.4477 5 12V22C5 22.5523 5.44772 23 6 23H16C16.5523 23 17 22.5523 17 22V12C17 11.4477 16.5523 11 16 11H6Z",
  fill: "#808080"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10 5.99997C9.44772 5.99997 9 6.44768 9 6.99997V7.99997H7V6.99997C7 5.34312 8.34315 3.99997 10 3.99997H20.5C22.1569 3.99997 23.5 5.34312 23.5 6.99997V17C23.5 18.6568 22.1569 20 20.5 20H20V18H20.5C21.0523 18 21.5 17.5523 21.5 17V6.99997C21.5 6.44768 21.0523 5.99997 20.5 5.99997H10Z",
  fill: "#808080"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M13.4853 16.6038C13.7453 16.8039 13.7453 17.196 13.4853 17.3962L10.305 19.8444C9.97621 20.0975 9.5 19.8631 9.5 19.4482V14.5518C9.5 14.1368 9.97621 13.9025 10.305 14.1556L13.4853 16.6038Z",
  fill: "#808080"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5 9.17068C3.83481 9.58251 3 10.6938 3 12V22C3 23.6568 4.34315 25 6 25H16C17.6569 25 19 23.6568 19 22V12C19 10.3431 17.6569 8.99997 16 8.99997H6C5.64936 8.99997 5.31278 9.06012 5 9.17068ZM22 19.5986C22.8967 19.0799 23.5 18.1104 23.5 17V6.99997C23.5 5.34312 22.1569 3.99997 20.5 3.99997H10C8.69378 3.99997 7.58254 4.83478 7.17071 5.99997C7.06015 6.31275 7 6.64933 7 6.99997V7.99997H9V6.99997C9 6.44768 9.44772 5.99997 10 5.99997H20.5C21.0523 5.99997 21.5 6.44768 21.5 6.99997V17C21.5 17.3701 21.2989 17.6933 21 17.8662C20.8529 17.9513 20.6821 18 20.5 18H20V20H20.5C20.6704 20 20.8374 19.9858 21 19.9585C21.359 19.8983 21.6963 19.7743 22 19.5986ZM6 11C5.44772 11 5 11.4477 5 12V22C5 22.5523 5.44772 23 6 23H16C16.5523 23 17 22.5523 17 22V12C17 11.4477 16.5523 11 16 11H6ZM13.4853 16.6038C13.7453 16.8039 13.7453 17.196 13.4853 17.3962L10.305 19.8444C9.97621 20.0975 9.5 19.8631 9.5 19.4482V14.5518C9.5 14.1368 9.97621 13.9025 10.305 14.1556L13.4853 16.6038Z",
  fill: "#808080"
});

var SvgIcMedia = function SvgIcMedia(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcMedia, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_media.e568729f.svg";
export { ForwardRef as ReactComponent };